import axiosInstance from './axiosInstance';
import { API_ROUTES } from './constants';

// Subscribers API functions
export const createSubscriber = async (subscriberData) => {
  try {
    const response = await axiosInstance.post(API_ROUTES.SUBSCRIBERS.CREATE, {
      name: subscriberData.name, // required
      city: subscriberData.city, // optional
      mobileNumber: subscriberData.mobileNumber, // required
    });
    return response.data;
  } catch (error) {
    console.error('Error creating subscriber:', error);
    throw error;
  }
};

export const updateSubscriber = async (subscriberId, updateData) => {
  try {
    const response = await axiosInstance.patch(`${API_ROUTES.SUBSCRIBERS.UPDATE}/${subscriberId}`, updateData);
    return response.data;
  } catch (error) {
    console.error('Error updating subscriber:', error);
    throw error;
  }
};

export const getSubscribers = async (queryParams = {}) => {
  try {
    const params = {
      page: queryParams.page || 1,
      search: queryParams.search || '',
    };
    const response = await axiosInstance.get(API_ROUTES.SUBSCRIBERS.GET_ALL, { params });
    return response.data;
  } catch (error) {
    console.error('Error fetching subscribers:', error);
    throw error;
  }
};

export const getAllSubscribersWithoutPagination = async () => {
  try {
    const response = await axiosInstance.get(API_ROUTES.SUBSCRIBERS.GET_ALL_WITHOUT_PAGINATION);
    return response.data;
  } catch (error) {
    console.error('Error fetching subscribers:', error);
    throw error;
  }
};

export const getSubscriber = async (subscriberId) => {
  try {
    const response = await axiosInstance.get(`${API_ROUTES.SUBSCRIBERS.GET}/${subscriberId}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching subscriber:', error);
    throw error;
  }
};

export const deleteSubscribers = async (subscriberIds) => {
  try {
    const response = await axiosInstance.delete(API_ROUTES.SUBSCRIBERS.DELETE, {
      data: {
        ids: subscriberIds // array of numbers, e.g., [1, 2, 3]
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error deleting subscribers:', error);
    throw error;
  }
};
